<template>
	<div class="container" :style="{backgroundImage: `url(${require('../../assets/image/bg_container.jpg')})`}">
		<div class="page-header" :style="{backgroundImage: `url(${require('../../assets/image/bg_header.png')})`}">
			<header-time ref="headerTime"></header-time>
			<header-about></header-about>
			<header-weather ref="headerWeather"></header-weather>
		</div>

		<div class="page-main">
			<div class="page-left">
				<DashboardOverview ref="DashboardOverview"/>
        <ChartXLTJ_Gasoline ref="ChartXLTJ_Gasoline"/>
        <ChartPhotoVoltaic  />
        <ChartGYYQ ref="ChartGYYQ" />
        <ChartXLTJ_Gas style="margin-top: 95px"/>
			</div>

			<div class="page-center">
				<div class="map">
					<box-header title="站点分布">
					</box-header> 

					<div class="map-main">
						<chart-map ref="ChartMap" @loadData="setMapData"></chart-map>
					</div>
				</div>

				<div class="box-sizing-bor" style="height: 500px;padding: 85px 70px;">
					<box-header title="今日数据">
              <div @click="jumpAiData" class="deepSeek">DEEPSEEK分析</div>
          </box-header>


					<div class="box today">
						<box-border angle left-top left-bottom right-top right-bottom></box-border>
						<DashboardToday ref="DashboardToday"></DashboardToday>
					</div>
				</div>
			</div>

			<div class="page-right">
        <div class="right-tab">
          <div class="right-tab-bar">
            <div
                class="tab-item"
                :class="{ active: rightTab === 'charge' }"
                @click="switchRightTab('charge')"
            >
              汽车充电站
            </div>
            <div
                class="tab-item"
                :class="{ active: rightTab === 'pv' }"
                @click="switchRightTab('pv')"
            >
              光伏电站
            </div>
          </div>

          <div class="right-tab-content">
            <ChartXLTJ_Charge ref="ChartXLTJ_Charge" v-show="rightTab === 'charge'"></ChartXLTJ_Charge>
            <ChartGufd ref="ChartGufd" v-show="rightTab === 'pv'"></ChartGufd>
          </div>
        </div>
        <ChartXLTJ_BicycleCharging ref="ChartXLTJ_BicycleCharging"/>
        <ConverterStationStatistics/>
        <ChartXLTJ_Photovoltaic ref="ChartXLTJ_Photovoltaic"/>
      </div>
		</div>
	</div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader";
import BoxBorder from "@/components/BoxBorder/BoxBorder";
import HeaderTime from "@/components/HeaderTime/HeaderTime";
import HeaderWeather from "@/components/HeaderWeather/HeaderWeather";
import HeaderAbout from "@/components/HeaderAbout/HeaderAbout.vue";
import ChartGYYQ from "@/components/ChartGYYQ/ChartGYYQ.vue"; // 工业用气
import ChartMap from "@/components/ChartMap/ChartMap.vue"; // 地图
import DashboardToday from "@/components/DashboardToday/DashboardToday"; // 今日数据
import ChartXLTJ_Charge from "@/components/ChartXLTJ_Charge/ChartXLTJ_Charge.vue";
import ChartXLTJ_Gasoline from "@/components/ChartXLTJ_Gasoline/ChartXLTJ_Gasoline.vue";
import ChartXLTJ_Photovoltaic from "@/components/ChartXLTJ_Photovoltaic/ChartXLTJ_Photovoltaic.vue";
import ChartXLTJ_Gas from "@/components/ChartXLTJ_Gas/ChartXLTJ_Gas.vue";
import DashboardOverview from "@/components/DashboardOverview/DashboardOverview.vue";
import ChartXLTJ_BicycleCharging from "@/components/ChartXLTJ_BicycleCharging/ChartXLTJ_BicycleCharging.vue";
import ChartPhotoVoltaic from "@/components/ChartPhotovoltaic/ChartPhotovoltaic.vue"; //充电桩列表
import ConverterStationStatistics from "@/components/ConverterStation/ConverterStationStatistics.vue";
import ChartGufd from "@/components/ChartGufd/ChartGufd.vue";
export default {
	components: {
    ChartGufd,
		ChartPhotoVoltaic,
		DashboardOverview,
		ChartXLTJ_Gas,
		ChartXLTJ_Gasoline,
		ChartXLTJ_Charge,
		BoxHeader,
		BoxBorder,
		HeaderTime,
		HeaderWeather,
		HeaderAbout,
		ChartGYYQ,
		ChartMap,
		DashboardToday,
    ChartXLTJ_BicycleCharging,
    ConverterStationStatistics,
    ChartXLTJ_Photovoltaic
	},
	data(){
		return {
			CDLPMType: 'month',
			timer: null,
			listTitle: '',
      rightTab: 'charge',
			listId: '',
			listData: [],
			listVisible: false,
			mapData: []
		}
	},
	created() {
		this.getData();
	},
	methods: {
		setMapData(data){
			this.mapData = data;
		},
    jumpAiData(){
      window.open(this.$router.resolve({ path: '/AI' }).href, '_blank');
    },
    switchRightTab(type){
      this.rightTab = type;
      // 如果你希望切换时立刻刷新一次数据（可选）
      this.$nextTick(() => {
        if (type === 'pv') {
          this.$refs.ChartGufd?.refreshChart && this.$refs.ChartGufd.refreshChart();
        } else {
          this.$refs.ChartXLTJ_Charge?.getData && this.$refs.ChartXLTJ_Charge.getData();
        }
      });
    },
		getData(){
			if(this.timer){
				clearInterval(this.timer);
				this.timer = null;
			}
			this.timer = setInterval(()=>{
        this.$refs.ChartXLTJ_Charge?.getData && this.$refs.ChartXLTJ_Charge.getData();
				this.$refs.ChartXLTJ_Gasoline.getData();
        this.$refs.ChartGYYQ.getData();
        this.$refs.ChartXLTJ_BicycleCharging.getData();
        this.$refs.DashboardToday.getData();
        this.$refs.DashboardOverview.getData();
        this.$refs.ChartXLTJ_Photovoltaic.getData();
			},10000);

		}
	}
};
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";

.page-left {
	width: 1030px;
	height: 100%;
}

.page-right {
	width: 960px;
	height: 100%;
}

.page-center {
	flex: 1;
	height: 100%;
}

.box {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	margin-bottom: 10px;

	&.today {
		height: 409px;
		padding: 30px;
	}
}

.box-header {
	display: flex;
	flex-direction: row;

	.title-border {
		width: 5px;
		height: calc(100% - 8px);
		background: rgba(144, 214, 255, 1);
		box-shadow: 0 0 12px rgba(80, 166, 255, .54);
		margin-top: 4px;
		margin-right: 8px;
	}

	.title-main {
		flex: 1;
		height: 100%;
		background: rgba(40, 95, 138, .4);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 32px;
		color: rgba(181, 228, 255, 1);
		font-family: "screen";
		box-sizing: border-box;
		padding: 0 20px;

		.title-value {
			font-size: 38px;
			color: rgba(255, 144, 130, 1);
		}

		.title-unit {
			font-size: 24px;
			color: rgba(211, 238, 254, .6);
			font-family: "Alibaba PuHuiTi", serif;
			margin-left: 20px;
		}
	}
}

.box-footer {
	.footer-main {
		flex: 1;
		height: 100%;
		background: rgba(40, 95, 138, .4);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 32px;
		color: rgba(181, 228, 255, 1);
		font-family: "screen", serif;
		box-sizing: border-box;
		padding: 0 20px;

		.footer-value {
			font-size: 38px;
			color: rgba(150, 236, 255, 1);
			line-height: 40px;
		}

		.footer-unit {
			font-size: 24px;
			color: rgba(211, 238, 254, .6);
			font-family: "Alibaba PuHuiTi", serif;
			margin-left: 20px;
			vertical-align: middle;
		}
	}
}

.box-block {
	width: 100%;
	background: rgba(40, 95, 138, .4);
}

.map {
	position: relative;
	box-sizing: border-box;
	//padding: 70px;
	width: 1631px;
	height: 1376px;
	margin: 0 auto;
	margin-top: 50px;
	.map-main {
		width: 100%;
		height: 100%;
		background: url("../../assets/image/bg_map_box.png") no-repeat center center / cover;
	}
}

.deepSeek{
  font-size: 36px;
  padding: 15px 30px;
  margin-right: 55px;
  font-family: "screen", serif;
  background: #f8f8f8;
  color: #09192e;
  border-radius: 13px;
  text-shadow: 0 0 1em rgb(117 136 158 / 56%), 0 0 1em rgb(62 152 255 / 56%);
  cursor: pointer;
}

.map-tab {
	position: absolute;
	top: 250px;
	right: 60px;
	display: flex;
	flex-direction: row;
	align-items: center;

	.tab-item {
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		width: 288px;
		height: 60px;
		margin-left: 40px;
		background: url("../../assets/image/bg_map_tab_un.png") no-repeat center center / 100%;
		box-sizing: border-box;
		font-size: 32px;
		font-family: 'screen', serif;
		color: rgba(165, 224, 255, .7);
		cursor: pointer;
		overflow: hidden;

		&.active {
			border-radius: 2px;
			border-color: rgba(181, 228, 255, 1);
			border-left-width: 10px;
			border-right-width: 10px;
			color: rgba(181, 228, 255, 1);
			background: url("../../assets/image/bg_map_tab_on.png") no-repeat center center / 100%;
		}
	}
}

.right-tab {
  position: relative;
  z-index: 999;
}

.right-tab-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  .tab-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 288px;
    height: 60px;
    background: url("../../assets/image/bg_map_tab_un.png") no-repeat center center / 100%;
    box-sizing: border-box;
    font-size: 32px;
    font-family: 'screen', serif;
    color: rgba(165, 224, 255, .7);
    cursor: pointer;
    overflow: hidden;

    &.active {
      border-radius: 2px;
      border-color: rgba(181, 228, 255, 1);
      border-left-width: 10px;
      border-right-width: 10px;
      color: rgba(181, 228, 255, 1);
      background: url("../../assets/image/bg_map_tab_on.png") no-repeat center center / 100%;
    }
  }
}
</style>
